

function StarRating({ rating, onRatingChange, questionKey, questionText }) {
    return (
        <div className="rating-item">
          <div className="rating-question">{questionText}</div>
          <div className="star-rating">
            {[1, 2, 3, 4, 5].map((star) => (
              <span key={star}
                className={`star ${star <= rating ? 'filled' : ''}`}
                onClick={() => onRatingChange(questionKey, star)}>
                ★
              </span>
            ))}
          </div>
        </div>
      );
    }
    

export default StarRating;
